import axiosInstance from "@config/axios";

const fetchPaymentApiUrl = "/payments/{id}?token={token}";

export const fetchPayment = async (id, token) => {
  return axiosInstance.get(
    fetchPaymentApiUrl.replace("{id}", id).replace("{token}", token)
  );
};
